import * as t from "react";
import { Ripple as _ } from "./portal.esm.79076359.js";
import { Tooltip as L } from "./tooltip.esm.f9603bda.js";
import { ObjectUtils as c, classNames as o, jsxs as r, Fragment as O, jsx as n, IconUtils as T } from "./utils.esm.ea524c19.js";
function f(e, a, l) {
  return a in e ? Object.defineProperty(e, a, {
    value: l,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[a] = l, e;
}
var d = /* @__PURE__ */ t.memo(/* @__PURE__ */ t.forwardRef(function(e, a) {
  var l = t.useRef(a);
  if (t.useEffect(function() {
    c.combinedRefs(l, a);
  }, [l, a]), e.visible === !1)
    return null;
  var g = function() {
    var i = e.loading ? e.loadingIcon : e.icon, B = o("p-button-icon p-c", f({
      "p-button-loading-icon": e.loading
    }, "p-button-icon-".concat(e.iconPos), e.label));
    return T.getJSXIcon(i, {
      className: B
    }, {
      props: e
    });
  }, m = function() {
    return e.label ? /* @__PURE__ */ n("span", {
      className: "p-button-label p-c",
      children: e.label
    }) : !e.children && !e.label && /* @__PURE__ */ n("span", {
      className: "p-button-label p-c",
      dangerouslySetInnerHTML: {
        __html: "&nbsp;"
      }
    });
  }, s = function() {
    if (e.badge) {
      var i = o("p-badge", e.badgeClassName);
      return /* @__PURE__ */ n("span", {
        className: i,
        children: e.badge
      });
    }
    return null;
  }, v = c.isNotEmpty(e.tooltip), b = e.disabled || e.loading, N = c.findDiffKeys(e, d.defaultProps), P = o("p-button p-component", e.className, f({
    "p-button-icon-only": (e.icon || e.loading && e.loadingIcon) && !e.label && !e.children,
    "p-button-vertical": (e.iconPos === "top" || e.iconPos === "bottom") && e.label,
    "p-disabled": b,
    "p-button-loading": e.loading,
    "p-button-loading-label-only": e.loading && !e.icon && e.label
  }, "p-button-loading-".concat(e.iconPos), e.loading && e.loadingIcon && e.label)), h = g(), I = m(), y = s(), R = e.label ? e.label + (e.badge ? " " + e.badge : "") : e["aria-label"];
  return /* @__PURE__ */ r(O, {
    children: [/* @__PURE__ */ r("button", {
      ref: l,
      "aria-label": R,
      ...N,
      className: P,
      disabled: b,
      children: [h, I, e.children, y, /* @__PURE__ */ n(_, {})]
    }), v && /* @__PURE__ */ n(L, {
      target: l,
      content: e.tooltip,
      ...e.tooltipOptions
    })]
  });
}));
d.displayName = "Button";
d.defaultProps = {
  __TYPE: "Button",
  label: null,
  icon: null,
  iconPos: "left",
  badge: null,
  badgeClassName: null,
  tooltip: null,
  tooltipOptions: null,
  disabled: !1,
  loading: !1,
  loadingIcon: "pi pi-spinner pi-spin",
  visible: !0
};
export {
  d as Button
};
